import React, { Component } from "react";
import { setLocale } from "../../helpers/translate";
import { setMicrositeColour } from "../../helpers/style";
import ModalComponent from "../common/ModalComponent";

import linkIcon from "../../Logos/MemberPortal/link-icon.svg";

import mshENLogo from "../../Logos/MSH-Square_EN.png";
import mshFRLogo from "../../Logos/MSH-Square_FR.png";
import FloatToTopButton from "../common/FloatToTopButton";
import AnnouncementFR from "./AnnouncementFR";
import AnnouncementEN from "./AnnouncementEN";
import PostalDisruption from "./PostalDisruption";
import ReactGA from "react-ga4";
import Icon from "react-fa";
import * as memberPortalTranslations from "./fr.json";
let config = require("config");

class MemberPortal extends Component {
  constructor(props) {
    setLocale(props.params.lang);
    setMicrositeColour(props.params.microsite);

    sessionStorage.setItem("hide_navbar", true);
    document.body.style.backgroundColor = "white";
    super(props);

    this.state = {
      policyNumber: "",
      hasError: false,
      errorMessage: null,
      showWalletCard: false,
      showPSHCPUpdateModal: false,
      showPostalDisruptionModal: false,
      lang: props.params.lang,
    };

    const measurementIds = config.default.MEMBER_PORTAL_LANDING_PAGE_GA_measurement_id;

    const GA_ID = props.params.lang === 'en' ? measurementIds.pshcp : measurementIds.rssfp;

    ReactGA.initialize(GA_ID);

    this.fireEvent("member_portal_landing_page");
  }

  translate(string){
    return this.state.lang === "fr" ? memberPortalTranslations[string] : string;
  }

  fireEvent(action, category = "member_portal") {

    const { microsite, lang } = this.props.params;
    const { policyNumber } = this.state;

    const eventObject = {
      hitType: "event",
      eventCategory: category,
      eventAction: action,
      eventLabel: microsite,
      school_name: microsite,
      locale: lang,
    };

    ReactGA.send(eventObject);
  }

  renderModal() {
    const { showPSHCPUpdateModal, lang} = this.state;

    if (showPSHCPUpdateModal) {
      return lang === "en" ? <AnnouncementEN /> : <AnnouncementFR />;
    }

    if(this.state.showPostalDisruptionModal) {
      return <PostalDisruption lang={this.state.lang} />;
    }
  }

  renderTitle() {
    if (this.state.showPSHCPUpdateModal) {
      return this.translate("Update from MSH International to PSHCP members");
    }

    if (this.state.showPostalDisruptionModal) {
      return this.translate("National postal disruption notice");
    }
  }

  renderFaqLink = (url, label, GA_EVENT) => (
    <a
      href="#"
      onClick={() => {
        this.fireEvent(GA_EVENT);
        window.open(url, "_blank");
      }}
      className="link"
    >
      {this.translate(label)}
      <img src={linkIcon} className="link-icon" />
    </a>
  );

  renderCanadaPostStrikeBanner() {
    return (
      <div className="info-banner">
        <div>
          {this.translate("National postal disruption notice: During the rotating labour disruption, MSH will continue to serve customers and process claims.")}
        </div>
        <div className="learn-how">
          {this.translate("Our mail service will operate as usual, however you may experience delays in mail service.")}
          <span href="#" className="link" onClick={() => {
            this.fireEvent("national_postal_disruption_notice");
            this.setState({ showPostalDisruptionModal: true });
          }}>
            {this.translate("Learn how.")}
            <Icon name="external-link" id="icon" />
          </span>
        </div>
      </div>
    )
  }

  render() {
    const { lang } = this.state;
    const newLang = lang === "en" ? "fr" : "en";

    const links = {
      compClaimForm: {
        en: "https://pshcp-msh.ca/document/Comprehensive_claims_incurred_outside_of_Canada_claimform.pdf",
        fr: "https://rssfp-msh.ca/document/Demande_de_reglement_pour_frais_engages_a_lexterieur_du_Canada_au_titre_de_la_protection_totale.pdf",
      },
      suppClaimForm: {
        en: "https://pshcp-msh.ca/document/Emergency_benefit_while_travelling_claimform.pdf",
        fr: "https://rssfp-msh.ca/document/Demande_de_reglement_au_titre_de_la_garantie-voyage_durgence.pdf",
      },
      faq: {
        en: "https://www.welcome.canadalife.com/pshcp/msh/msh-faq.html",
        fr: "https://www.bienvenue.canadavie.com/rssfp/msh/faq-msh.html",
      },
      privacy: {
        en: "https://pshcp-msh.ca/document/Privacy_Disclaimer.pdf",
        fr: "https://rssfp-msh.ca/document/Protection_des_renseignements_personnels.pdf",
      },
      PSHCPMemberServiceWebsite: {
        en: "https://www.welcome.canadalife.com/pshcp",
        fr: "https://www.bienvenue.canadavie.com/rssfp",
      },
      publicServiceHealthCarePlan: {
        en: "https://www.pshcp.ca/",
        fr: "https://www.rssfp.ca/",
      },
      membersWithSuppCoverage: {
        en: "https://www.pshcp-msh.ca/a/eta",
        fr: "https://www.rssfp-msh.ca/a/eta",
      },
      membersWithCompCoverage: {
        en: "https://www.pshcp-msh.ca/a/comp",
        fr: "https://www.rssfp-msh.ca/a/comp",
      },
      leavingCanada: {
        en: "https://pshcp-msh.ca/document/Deployment_Leaving_Canada.pdf",
        fr: "https://rssfp-msh.ca/document/Deploiement_Vous_quittez_le_Canada.pdf",
      },
      returnToCanada: {
        en: "https://pshcp-msh.ca/document/Deployment_Returning_to_Canada.pdf",
        fr: "https://rssfp-msh.ca/document/Deploiement_Vous_revenez_au_Canada.pdf",
      },
      memberBooklet:{
        en: "https://www.welcome.canadalife.com/content/dam/rfp/welcome-sites/pshcp/PSHCP-member-booklet.pdf",
        fr: "https://rssfp-msh.ca/document/Livret_du_participant_du_RSSFP.pdf",
      }
    };

    const showModal = this.state.showPSHCPUpdateModal || this.state.showPostalDisruptionModal;

    return (
      <div className="member-portal">
        <a className="skip-to-content" href="#main-id">
          Skip to content
        </a>
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light">
            <div className="container">
              <div className="navbar-brand">
                <img
                  src={lang == "en" ? mshENLogo : mshFRLogo}
                  width="60"
                  height="60"
                  alt="MSH Canada"
                />
              </div>
              <span
                className="row-flex navbar-lang"
                onClick={() => {
                  const member_portal_url_en = "https://pshcp-msh.ca";
                  const member_portal_url_fr = "https://rssfp-msh.ca";

                  if (location.hostname !== "dashboard.studyinsured.com") {
                    location.replace(`/msh/member_portal/${newLang}`);
                  } else {
                    parent.location.href = eval(
                      `member_portal_url_${newLang}`
                    );
                  }
                }}
              >
                {newLang.toUpperCase()}
              </span>
            </div>
          </nav>
        </div>

        <div className="main-wrapper">
          <div className="container">
            <div className="row text-center">
              <h1 className="mp-h1">
                {this.translate("Welcome to the MSH Public Service Health Care Plan (PSHCP) Member Portal")}
              </h1>
              <h2 className="mp-h2">
                {this.translate("MSH International (MSH) is your Emergency Travel Assistance and Comprehensive Coverage provider for the Public Service Health Care Plan (PSHCP)")}
              </h2>
            </div>
          </div>
        </div>

        <div className="container mp-box">
          <h2>{this.translate("Log in or register for your account")}</h2>
          <div className="row">
            <div className="col-md-6">
              <div className="mp-box-header">
                <h2 className="mp-box-title">
                  {this.translate("Members with Supplementary Coverage")}
                </h2>
              </div>
              <div className="mp-box-body">
                <p className="mp-box-descprition">
                  {this.translate("(incurring emergency expenses while travelling):")}
                </p>
                <button
                  className="btn button-secondary mp-button"
                  tabIndex="0"
                  onClick={() => {
                    this.fireEvent("login_or_register_members_with_supp_coverage");
                    window.open(links.membersWithSuppCoverage[lang], "_blank");
                  }}
                >
                  <span className="row-flex">
                    {this.translate("Log in or register")}
                    <div className="mp-arrow" />
                  </span>
                </button>
              </div>
            </div>
            <div className="vertical" />
            <div className="col-md-6">
              <div className="mp-box-header">
                <h2 className="mp-box-title">
                  {this.translate("Members with Comprehensive Coverage")}
                </h2>
              </div>

              <div className="mp-box-body" id="main-id">
                <p className="mp-box-descprition">
                  {this.translate(
                    "(incurring expenses outside of Canada while posted, deployed, or living abroad):"
                  )}
                </p>
                <button
                  className="btn button-secondary mp-button"
                  onClick={() => {
                    this.fireEvent("login_or_register_members_with_comp_coverage");
                    window.open(links.membersWithCompCoverage[lang], "_blank");
                  }}
                >
                  <span className="row-flex">
                    {this.translate("Log in or register")}
                    <div className="mp-arrow" />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="center-children" style={{ padding: "0 30px" }}>
          <button
            className="btn button-secondary mp-button update-button"
            onClick={() => {
              this.setState({ showPSHCPUpdateModal: true });
              this.fireEvent("PSHCP_members_update");
            }}
          >
            {this.translate("Update from MSH International to PSHCP members")}
          </button>
        </div>

        <div className="claims-info">
          <h2 className="title">{this.translate("MSH processes the following claims:")} </h2>
          <ul>
            <li>
              {this.translate(
                "Emergency Travel Assistance (ETA) claims for members with Supplementary Coverage"
              )}
            </li>
            <li>
              {this.translate(
                "Claims for expenses incurred outside of Canada for members with Comprehensive Coverage"
              )}
            </li>
          </ul>

          <p>
            {this.translate("All other claims should be submitted to")}
            <a
              href="#"
              onClick={() => {
                this.fireEvent("claims_canada_life");
                window.open(links.PSHCPMemberServiceWebsite[lang], "_blank");
              }}
              className="link"
            >
              {this.translate("Canada Life")}
              <img src={linkIcon} className="link-icon-img" />.
            </a>
          </p>
        </div>

        <div className="claims-form">
          <h2>{this.translate("Claim Forms")}</h2>
          <div>
            {this.translate("Supplementary Coverage:")}
            <a
              href="#"
              onClick={() => {
                this.fireEvent("claims_form_supplementary");
                window.open(links.suppClaimForm[lang], "_blank");
              }}
              className="link"
            >
              <span className="link-text">
                {this.translate("Emergency Benefit While Travelling Claim Form")}
                <img src={linkIcon} className="link-icon-img" />
              </span>
            </a>
          </div>

          <div>
            {this.translate("Comprehensive Coverage:")}
            <a
              href="#"
              onClick={() => {
                this.fireEvent("claims_form_comprehensive");
                window.open(links.compClaimForm[lang], "_blank");
              }}
              className="link"
            >
              <span className="link-text">
                {this.translate(
                  "Comprehensive Claims Incurred Outside of Canada Claim Form"
                )}
                <img src={linkIcon} className="link-icon-img" />
              </span>
            </a>
          </div>
        </div>

        <hr />

        <div className="contact center-children">
          <div className="row contact-flex">
            <div className="col-md-7 flex-column">
              <h2 className="title">{this.translate("Contact us")}</h2>
              <div className="box flex-grow">
                <div className="row">
                  <div className="col-md-6">
                    <h3 className="box-title">
                      <div className="phone-logo" />
                      {this.translate("Phone")}
                    </h3>

                    <div className="box-content">
                      <div className="box-subtitle">
                        {this.translate("NORTH AMERICA (Toll-free):")}
                      </div>
                      <div className="number">
                        <span>1-833-774-2700
                          {lang === "en" && <span> (24/7)</span>}
                          {lang === "fr" && <span> (24 h/7 j)</span>}
                        </span>
                        {lang === "en" && <span>(1-833-PSHCP-00)</span>}
                      </div>

                      <div className="box-subtitle">
                        {this.translate("INTERNATIONAL (COLLECT):")}
                      </div>
                      <div className="number">
                        <span>1-365-337-7427
                          {lang === "en" && <span> (24/7)</span>}
                          {lang === "fr" && <span> (24 h/7 j)</span>}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="box-divider" />

                  <div className="col-md-6">
                    <h3 className="box-title">
                      <div className="mail-logo" />
                      {this.translate("Claims address")}
                    </h3>

                    <div className="box-content">
                      <div className="address-text">
                        <span>MSH International</span>
                        <span>{this.translate("PO Box 4903, Stn A")}</span>
                        <span>Toronto, ON, M5W 0B1</span>
                        <span>Canada</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-5 flex-column">
              <h2 className="title">{this.translate("Key Information")}</h2>
              <div className="box flex-grow">
                <div className="box-content">
                  {this.renderFaqLink(links.memberBooklet[lang], "PSHCP - Member Booklet", "key_information_member_booklet")}
                  {this.renderFaqLink(links.faq[lang], "Frequently asked questions", "key_information_faq")}
                  {this.renderFaqLink(links.PSHCPMemberServiceWebsite[lang], "PSHCP Member Services website", "key_information_PSHCP_member_services")}
                  {this.renderFaqLink(links.publicServiceHealthCarePlan[lang], "PSHCP Administration Authority", "key_information_PSHCP_administration_authority")}
                  {this.renderFaqLink(links.leavingCanada[lang], "Deployment: Leaving Canada?", "key_information_leaving_canada")}
                  {this.renderFaqLink(links.returnToCanada[lang], "Deployment: Returning to Canada?", "key_information_return_to_canada")}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer">
          <div className="left">
            <p>© MSH International (Canada) Ltd., {new Date().getFullYear()}</p>
          </div>

          <div className="right">
            <a
              href="#"
              onClick={() => {
                this.fireEvent("footer_privacy");
                window.open(links.privacy[lang], "_blank");
              }}
            >
              {this.translate("Privacy")}
              <div className="link-icon" />
            </a>
            <a
              href="#"
              onClick={() => {
                this.fireEvent("footer_faq");
                window.open(links.faq[lang], "_blank");
              }}
            >
              {this.translate("FAQ")}
              <div className="link-icon" />
            </a>
          </div>
        </div>
        <ModalComponent
          title={this.renderTitle()}
          body={this.renderModal()}
          onClose={this.setState.bind(this, { showPSHCPUpdateModal: false, showPostalDisruptionModal: false })}
          show={showModal}
          resetDataOnClose={false}
          size="large"
        />
        <FloatToTopButton />
      </div>
    );
  }
}

MemberPortal.displayName = "Member Portal";
export default MemberPortal;



// WEBPACK FOOTER //
// ./src/components/MemberPortal/MemberPortal.js